import { QuestionTitle } from "../QuestionTitle"
import { Answer } from "./Answer"
import type { IAnswerProps } from "./types"

export function QuestionAnswer(props: IAnswerProps) {
  const { question } = props
  return (
    <Answer {...props}>
      <QuestionTitle question={question} />
    </Answer>
  )
}
